// extracted by mini-css-extract-plugin
export default {"segment-rule-form":"segment-rule-form_Qk0wF"};